__turbopack_context__.v({
  "btn": "OutdatedBrowser-module__jlp2MG__btn",
  "container": "OutdatedBrowser-module__jlp2MG__container",
  "fadeInItems": "OutdatedBrowser-module__jlp2MG__fadeInItems",
  "link": "OutdatedBrowser-module__jlp2MG__link",
  "spacing--lg": "OutdatedBrowser-module__jlp2MG__spacing--lg",
  "spacing--md": "OutdatedBrowser-module__jlp2MG__spacing--md",
  "spacing--sm": "OutdatedBrowser-module__jlp2MG__spacing--sm",
  "spacing--xl": "OutdatedBrowser-module__jlp2MG__spacing--xl",
  "spacing--xs": "OutdatedBrowser-module__jlp2MG__spacing--xs",
  "spacing--xxl": "OutdatedBrowser-module__jlp2MG__spacing--xxl",
  "spacing--xxs": "OutdatedBrowser-module__jlp2MG__spacing--xxs",
  "spacing--xxxl": "OutdatedBrowser-module__jlp2MG__spacing--xxxl",
  "spacing--xxxs": "OutdatedBrowser-module__jlp2MG__spacing--xxxs",
  "title": "OutdatedBrowser-module__jlp2MG__title",
});
